/**
 * Route for `retargeting-pixel`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RetargetingPixelPage } from "../features/retargeting-pixel/RetargetingPixelPage";

export const retargetingPixelRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/retargeting-pixel",
	component: RetargetingPixelPage,
});

export default retargetingPixelRoute;
